import { render, staticRenderFns } from "./DrawingHighlights.vue?vue&type=template&id=0ce5db87&scoped=true"
import script from "./DrawingHighlights.vue?vue&type=script&lang=js"
export * from "./DrawingHighlights.vue?vue&type=script&lang=js"
import style0 from "./DrawingHighlights.vue?vue&type=style&index=0&id=0ce5db87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce5db87",
  null
  
)

export default component.exports